import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Challenge, ChallengesResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ChallengesDataService {

  private uri: string = `${environment.apiUrl}banners`;
  private cacheKey: string = 'challenges.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getChallenge(id: number): Observable<Challenge|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getChallenges(parameters: {[param: string]: string | string[]}): Observable<ChallengesResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addChallenge(data: Challenge): Observable<Challenge|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addChallenges(data: Challenge[]): Observable<Challenge[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateChallenge(data: Challenge): Observable<Challenge|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateChallenges(data: Challenge[]): Observable<Challenge[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchChallenge(data: Challenge): Observable<Challenge|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchChallenges(data: Challenge[]): Observable<Challenge[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteChallenge(data: Challenge): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteChallenges(data: Challenge[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((challenge) => {
      ids.push(challenge.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
